﻿import PersonalDetails from "./PersonalDetails.svelte";
import SurgeryDetails from "./SurgeryDetails.svelte";
import TreatmentDetails from "./TreatmentDetails.svelte";


const confirmationPages = [
    {
        component: PersonalDetails,
        routeId: "/Questionnaire/PersonalDetails",
        confirmationHeading: "Your details",
    },    
    {
        component: SurgeryDetails,
        routeId: "/Questionnaire/SurgeryDetails",
        confirmationHeading: "Surgery details",
    },
    {
        component: TreatmentDetails,
        routeId: "/Questionnaire/TreatmentDetails",
        confirmationHeading: "Treatment details",
    },
];

export default confirmationPages;